import { render, staticRenderFns } from "./dashGroupStudents.vue?vue&type=template&id=1616bf15&scoped=true"
import script from "./dashGroupStudents.vue?vue&type=script&lang=js"
export * from "./dashGroupStudents.vue?vue&type=script&lang=js"
import style0 from "./dashGroupStudents.vue?vue&type=style&index=0&id=1616bf15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1616bf15",
  null
  
)

export default component.exports